<dx-popup
  [showTitle]="true"
  title="Export CEGID impossible"
  [visible]="displayDialog()"
  (onHidden)="closeDialog()"
  [width]="'80%'"
  [height]="'auto'"
  [maxHeight]="'80%'"
  [resizeEnabled]="true"
  [showCloseButton]="true">

  <p>
    L'export n'a pas été réalisé : les éléments ci-dessous n'ont pas de liaison avec un compte comptable
    et/ou une taxe. Corrigez-les puis relancez l'export.
  </p>

  <dx-data-grid
    [dataSource]="errorList()"
    class="datagrid"
    [showBorders]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    noDataText="Pas de données">

    <dxo-state-storing
      [enabled]="true"
      type="localStorage"
      storageKey="cegid-export-errors-dialog">
    </dxo-state-storing>

    <dxi-column dataField="type" caption="Type" cellTemplate="typeTemplate" [width]="90"></dxi-column>
    <dxi-column dataField="numero" caption="Numéro"></dxi-column>
    <dxi-column dataField="articleReference" caption="Référence article"></dxi-column>
    <dxi-column dataField="articleLibelle" caption="Article"></dxi-column>
    <dxi-column dataField="tauxTva" caption="Taux TVA" width="80px"></dxi-column>
    <dxi-column dataField="motif" caption="Motif" cellTemplate="motifTemplate"></dxi-column>

    <div *dxTemplate="let cell of 'typeTemplate'">
      {{ getTypeLabel(cell.row.data) }}
    </div>

    <div *dxTemplate="let cell of 'motifTemplate'">
      {{ getMotifLabel(cell.row.data) }}
    </div>
  </dx-data-grid>
</dx-popup>
